/* eslint-disable */
import React, { forwardRef } from 'react'

import { DadosCertificado } from 'src/servicos/api/sala-aula/tipos'

import { CertificadoExtensaoTemplate } from './certificado-extensao-template'
import { CertificadoLegadoTemplate } from './certificado-legado-template'

const ehCertificadoEvento = (modalidade?: string) => modalidade === 'Evento'

export const CertificadoTemplate = forwardRef<
  HTMLDivElement,
  { certificado: DadosCertificado; dataEmissao?: string }
>(({ certificado, dataEmissao }, ref) => {
  if (ehCertificadoEvento(certificado.modalidade)) {
    return (
      <CertificadoLegadoTemplate
        certificado={certificado}
        dataEmissao={dataEmissao}
        ref={ref}
      />
    )
  }

  return <CertificadoExtensaoTemplate certificado={certificado} ref={ref} />
})
